import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { STYLES } from "./ShoppingCartStyles";
import { Icon } from "../liquid/LiquidPrimitives";

interface DrawerHeaderProps {
    onClose: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ onClose }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
        }}
    >
        <Typography
            variant="h6"
            sx={{
                fontFamily: STYLES.fontFamily,
                fontWeight: "bold",
                fontSize: "22px",
                color: "#1a1c1e",
            }}
        >
            Carrito de Compras
        </Typography>

        <button
            type="button"
            onClick={onClose}
            style={{
                width: 34,
                height: 34,
                borderRadius: 999,
                border: "none",
                background: "rgba(26,28,30,0.08)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#1a1c1e",
                flexShrink: 0,
            }}
        >
            <Icon.close style={{ width: 16, height: 16 }} />
        </button>
    </Box>
);
